import type { BoggleChallengeBonusId } from '~/boggle/config/bonuses/types'
import { anchorLetterBonusDefinition } from './definitions/anchorLetter'
import { doubleLetterBonusDefinition } from './definitions/doubleLetter'
import { palindromeBonusDefinition } from './definitions/palindrome'
import { longshotBonusDefinition, shotgunBonusDefinition } from './definitions/wordLengthBonus'
import { noRepeatsBonusDefinition } from './definitions/noRepeats'
import type { BoggleChallengeBonusDefinition } from './bonusDefinition'
import { vowelScarcityBonusDefinition } from './definitions/vowelScarcity'

export const BOGGLE_CHALLENGE_BONUS_REGISTRY: Record<
  BoggleChallengeBonusId,
  BoggleChallengeBonusDefinition
> = {
  'anchor-letter': anchorLetterBonusDefinition,
  'double-letter': doubleLetterBonusDefinition,
  longshot: longshotBonusDefinition,
  palindrome: palindromeBonusDefinition,
  shotgun: shotgunBonusDefinition,
  'no-repeats': noRepeatsBonusDefinition,
  'vowel-scarcity': vowelScarcityBonusDefinition,
}
export function getBoggleChallengeBonusDefinition(bonusId: BoggleChallengeBonusId) {
  return BOGGLE_CHALLENGE_BONUS_REGISTRY[bonusId]
}

export function getBoggleChallengeBonusDefinitions(
  bonusIds: readonly BoggleChallengeBonusId[]
) {
  return bonusIds.map(bonusId => getBoggleChallengeBonusDefinition(bonusId))
}
